import React from "react";
import "./App.css";
import Container from './component/Container'



function App() {
  return (
    <>
      <Container/>
    </>
  );
}

export default App;
